module.exports = __webpack_public_path__ + "static/advanced-carousel-3bc6882bce2bdacd9a409720266507f9.png";